<template>
  <div class="mb-3 text-left">
    <LabelComponent>{{ props.label }}</LabelComponent>
    <select
      class="bg-white border border-gray-300 text-back text-sm rounded-lg focus:ring-blue-500 focus:border-gray-300 block w-full p-2.5 dark:bg-white dark:border-gray-300 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
      :modelValue="validSelection"
      :value="validSelection"
      @change="updateValue($event)"
      :disabled="props.selections.length === 1"
    >
      <option v-for="option in props.selections" :key="option.value" :value="option.value" class="text-black">
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import LabelComponent from '../ui/label/LabelComponent.vue';

const props = defineProps<{
  label: string;
  selections: Array<any>;
  modelValue?: number | string;
}>();

const validSelection = ref(props.modelValue);

const emit = defineEmits(['update:modelValue']);

const updateValue = (event: any) => {
  const value = event.target.value;
  const parsedValue = isNaN(Number(value)) ? value : Number(value);
  emit('update:modelValue', parsedValue);
};

const processSelectionInput = (selection: number | string | undefined) => {
  if (selection === undefined || selection === null) {
    validSelection.value = undefined;
    return;
  }

  // Handle both object-based and primitive selections
  const isValidSelection = props.selections.some((s) => {
    const optionValue = s.value || s;
    return optionValue === selection || optionValue === selection.toString();
  });

  if (isValidSelection) {
    validSelection.value = selection;
  } else {
    validSelection.value = undefined;
  }
};

processSelectionInput(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    processSelectionInput(newValue);
  },
);
</script>
